// src/utils/franchiseTransformer.ts
import { Restaurant } from '../types/restaurant';

/**
 * Transform a single franchise object from the V2 API to Restaurant type
 * @param franchise - Franchise object from /snapmenu/v1/franchise/domain API
 * @returns Restaurant object compatible with existing application
 */
export function transformFranchiseToRestaurant(franchise: any): Restaurant {
  return {
    restaurant_id: franchise.id || '',
    restaurant_parent_id: franchise.parentRestaurantId || '',
    phone: franchise.contactInfo?.phone || '',
    cusine_type: franchise.settings?.cuisineTypes?.[0] || null,
    restaurant_name: franchise.name || '',
    description: franchise.restaurantDetails?.description || null,
    owner: null,
    restaurant_location: franchise.location?.city || null,
    restaurant_address: franchise.location?.address || '',
    domain: franchise.domain?.web || '',
    last_updated_sku_id: null,
    last_updated_sku_id_for_modifier: null,
    pre_lunch: '',
    post_lunch: '',
    working_hours: JSON.stringify(franchise.workingHours || {}),
    customer_care_number: franchise.contactInfo?.phone || null,
    image: franchise.restaurantDetails?.images?.[0]?.url || null,
    banner: franchise.restaurantDetails?.images
      ?.filter((img: any) => img.type === 'gallery')
      .map((img: any) => img.url) || [],
    logo: [],
    created_date: franchise.createdAt || '',
    updated_date: franchise.updatedAt || '',
    catalog_status: 'active',
    is_deleted: false,
    is_merchant_accepted: true,
    features: '',
    template_id: '',
    payment_type: null,
    state: franchise.location?.state || '',
    country: franchise.location?.country || '',
    zipcode: franchise.location?.zipcode || '',
    address: franchise.location?.address || '',
    lat: franchise.location?.coordinates?.lat?.toString() || '',
    lng: franchise.location?.coordinates?.lng?.toString() || '',
    account_id: franchise.accountId || '',
    package_details: JSON.stringify(['website_management']),
    drinks_menu_catalog_status: 'active',
    dietary_certification: JSON.stringify({}),
    is_enabled: franchise.isActive || false,
    is_voice_enabled: false,
    payment_perferences: JSON.stringify({}),
    alternative_phone: '',
  };
}

/**
 * Transform an array of franchise objects to Restaurant array
 * @param franchises - Array of franchise objects from API
 * @returns Array of Restaurant objects
 */
export function transformFranchisesToRestaurants(franchises: any[]): Restaurant[] {
  return franchises.map(transformFranchiseToRestaurant);
}
